import styled from 'styled-components';

import { colors } from 'theme/theme';

export const CmsReactionsContainer = styled.div`
  height: 160px;
  border-radius: 4px;
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.18);
`;

export const CmsReactionsWrapper = styled.div`
  border-bottom: 1px solid ${colors.elementGrey};
  padding: 32px 20px;
`;
